import { isEmpty } from '../../utils';
import { hasPermission } from '../../utils/permission';

/**
 * kAI visibility gate (admin). Requires `fetch.kai` AND membership on the
 * mandatory `KAI_USERS` email allowlist from app settings. An empty/absent
 * allowlist means nobody can see kAI.
 */
export const canViewKai = (user, appSettings) => {
  const { KAI_USERS = [] } = appSettings || {};

  return (
    hasPermission(user, 'fetch.kai') &&
    !isEmpty(KAI_USERS) &&
    !isEmpty(user) &&
    KAI_USERS.includes(user.email)
  );
};

export default canViewKai;
